export enum DRAWER_TYPES {
  ADD = "ADD",
  EDIT = "EDIT",
  DELETE = "DELETE",
  VIEW = "VIEW",
  INTEGRATION_INSTRUCTIONS = "INTEGRATION_INSTRUCTIONS",
  CONFIGURATION = "CONFIGURATION",
  ACCEPT = "ACCEPT",
  REJECT = "REJECT",
  ENTER_WO = "ENTER_WO",
  RESUBMIT = "RESUBMIT",
  NOTIFICATION = "NOTIFICATION",
}
